import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  Inject,
  ElementRef,
} from "@angular/core";
import { WorkForceService } from "../../../shared/services/work-force.service";
import { NgxSpinnerService } from "ngx-spinner";
import textConfiguration from "../../../../assets/static-text-configuration.json";
import { Router, ActivatedRoute } from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { FormBuilder } from "@angular/forms";
import { Subject, forkJoin, of } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { CommonService } from "../../../shared/services/common.service";
import { LoggingService } from "../../../logging.service";
import { ZohoService } from "../../../shared/services/zoho.service";
import { MessageService } from "../../../shared/services/message.service";

declare var ZAnalyticsLib: any;
@Component({
  selector: "app-people-insights",
  templateUrl: "./people-insights.component.html",
  styleUrls: ["./people-insights.component.scss"],
})
export class PeopleInsightsComponent implements OnInit {
  @ViewChild("reportView", { static: false }) reportView!: ElementRef;
  deliveryText: any = (textConfiguration as any).delivery;
  workforceText: any = (textConfiguration as any).workforce_dashboard;
  monthsList: any = this.deliveryText.month_list;
  commonText: any = (textConfiguration as any).common;
  sortRecords: any = 20;
  CurrentPage: any = 0;
  EndValue: any = 20;
  startValue: any = 0;
  activeTab: any = 0;
  firstTimeLoad = true;
  allResourceList: any = {
    data: [],
    count: 0,
  };
  allAttritionList: any = {
    data: [],
    count: 0,
  };
  allKRRList: any = {
    data: [],
    count: 0,
  };
  filterObj: any;
  filterString: any = "";
  workForceResourceForm: any;
  editingResourceId: any;
  selectedTab: any;
  pagename = "Emerging Trends in Distributed Agile Delivery";
  loading: any = false;
  workforceCatalogTab = 6;
  browseAIData: any = [];
  dataLoaded = false;
  filterCfg: any;
  displayLabels: any;
  jobCategoryList: any = [];
  jobClassificationList: any = [];
  countriesList: any = [];
  warningText = "Unexpected value";
  @ViewChild("showErrorLogTable", { static: false })
  showErrorLogTable: TemplateRef<any>;
  resourcesEndValue: any = 20;
  krrEndValue: any = 20;
  attritionEndValue: any = 20;
  resourcesStartValue: any = 0;
  krrStartValue: any = 0;
  attritionStartValue: any = 0;
  resourcesSortRecords: any = 20;
  krrSortRecords: any = 20;
  filterPayload: any = "";
  attritionSortRecords: any = 20;
  resourcesCurrentPage: any = 0;
  krrCurrentPage: any = 0;
  attritionCurrentPage: any = 0;
  MIN_ITEMS = 5;
  SMALL_BATCH = 10;
  MEDIUM_BATCH = 20;
  LARGE_BATCH = 50;
  XL_BATCH = 100;
  XXL_BATCH = 150;
  MAX_ITEMS = 200;
  sortOpt: any = [
    this.MIN_ITEMS,
    this.SMALL_BATCH,
    this.MEDIUM_BATCH,
    this.LARGE_BATCH,
    this.XL_BATCH,
    this.XXL_BATCH,
    this.MAX_ITEMS,
  ];
  resourcesSortOptions: any;
  krrSortOptions: any;
  attritionSortOptions: any;
  zohoReports: any = [];
  currentReportUrl: any;
  vizObj: any;
  breadcrumb: any;
  userDetails: any;
  breadCrumbData: any;
  private readonly unsubscribe$ = new Subject<void>();

  dashboardTabs = [
    { id: "tab1", name: "Location Spread" },
    { id: "tab2", name: "Persona/Profile Analysis" },
    { id: "tab3", name: "Cost/Rate Analysis" },
    { id: "tab4", name: "Data Access Analysis" },
    { id: "tab5", name: "Attrition Analysis" },
  ];

  dashboardTabsByIndex = [0, 1, 2, 3, 4];
  activeTabName = this.dashboardTabs[0].id;
  activeTabIndex = 0;
  displayLables: any = {};

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public readonly dialogRef: MatDialogRef<PeopleInsightsComponent>,
    private readonly router: Router,
    private readonly workForceService: WorkForceService,
    private readonly spinner: NgxSpinnerService,
    private readonly dialog: MatDialog,
    private readonly fb: FormBuilder,
    private readonly commonService: CommonService,
    private readonly loggingService: LoggingService,
    private readonly zohoService: ZohoService,
    private readonly messageService: MessageService
  ) {
    this.workForceResourceForm = this.fb.group({
      resource_id: [""],
      resource_name: [""],
      job_category: [""],
      job_title: [""],
      company_name: [""],
      classification: [""],
      country: [""],
      krr_classification: [""],
      krr_risk_mitigation_plan: [""],
      work_permit: [""],
      work_permit_expiry_date: [""],
      work_permit_renewal_plan: [""],
      wp_contingency_plan: [""],
      no_of_resource_having_exception_production_access: ["No"],
      no_of_resource_having_exception_generic_id: ["No"],
      no_of_resource_having_exception_pii_access: [""],
      no_of_resource_having_exception_pci_access: [""],
      no_of_resource_having_exception_phi_access: [""],
      no_of_resource_having_exception_cross_border_data_access: [""],
      sow_model: [""],
      approved_by_dl_manager: [""],
      resignation_date: [""],
      dl_notified_date: [""],
      lwd: [""],
      notice_period: [""],
      replacement_status: [""],
      replacement_start_date: [""],
      replacement_name: [""],
      kt_plan: [""],
    });
  }

  ngOnInit(): void {
    console.log(this.data);
    this.displayLabels = this.commonService.getLabels();
    this.breadCrumbData = ["People Insights"];
    if (this.data.projectName) {
      this.breadCrumbData.push(
        this.displayLabels?.project,
        this.data.projectName
      );
    } else if (this.data.programName) {
      this.breadCrumbData.push(
        this.displayLabels?.program ?? "Program",
        this.data.programName
      );
    } else if (this.data.subportfolioName) {
      this.breadCrumbData.push(
        this.displayLabels?.sub_portfolio ?? "Sub Portfolio",
        this.data.subportfolioName
      );
    } else if (this.data.portfolioName) {
      this.breadCrumbData.push(
        this.displayLabels?.portfolio ?? "Portfolio",
        this.data.portfolioName
      );
    } else {
      this.breadCrumbData.push(this.displayLabels?.all_of_it);
    }
    this.userDetails = JSON.parse(localStorage.getItem("permission") ?? "{}");
    this.resourcesSortOptions = JSON.parse(JSON.stringify(this.sortOpt));
    this.krrSortOptions = JSON.parse(JSON.stringify(this.sortOpt));
    this.attritionSortOptions = JSON.parse(JSON.stringify(this.sortOpt));
    this.getDisplayLables();
    this.filterPayload = this.filterZohoSurveys(this.data);
    this.getZohoSurveys();
  }

  initDashboard() {
    if (!this.reportView || !this.currentReportUrl) return;
    const reportOptions = {
      width: "100%",
      height: window.innerHeight - 130,
      defaultConfig: { hideDashboardTab: true },
    };

    this.vizObj = new ZAnalyticsLib(
      this.reportView.nativeElement,
      this.currentReportUrl,
      reportOptions
    );
    this.vizObj.createViz();
  }

  isEmptyValue(val: any): boolean {
    return (
      val === undefined ||
      val === null ||
      val === "" ||
      (Array.isArray(val) && val.length === 0) ||
      (typeof val === "object" &&
        !Array.isArray(val) &&
        Object.keys(val).length === 0)
    );
  }

  filterZohoSurveys(data: any) {
    this.dataLoaded = false;
    let payload = "";
    const BASE_TABLE = '"delivery_workforcedashboard"';
    let portfolio = data.portfolioName;
    let subportfolio = data.subportfolioName;
    let program = data.programName;
    let project = data.projectName;
    let vendor = "";
    let month = "";
    let jobCategory = "";

    // Buiding Query
    if (vendor) {
      payload += `${BASE_TABLE}."company_name" in ('${vendor}')`;
      // this.brea
    } else if (project) {
      payload += `${BASE_TABLE}."project_name" in ('${project}')`;
    } else if (program) {
      payload += `${BASE_TABLE}."resource_pool_name" in ('${program}')`;
    } else if (subportfolio) {
      payload += `${BASE_TABLE}."cost_center_name" in ('${subportfolio}')`;
    } else if (portfolio) {
      payload += `${BASE_TABLE}."portfolio_name" in ('${portfolio}')`;
    }

    if (month) {
      payload +=
        (payload ? " and " : "") + `${BASE_TABLE}."month" in (${month})`;
    }

    if (jobCategory) {
      payload +=
        (payload ? " and " : "") +
        `${BASE_TABLE}."job_category" in (${jobCategory})`;
    }

    return payload;
  }

  getZohoSurveys() {
    this.dataLoaded = false;
    let qParam = ``;
    let criteria = "";

    if (
      (this.data.projectLevel === "projectLevel" && this.data.projectId) ||
      this.data.projectName
    ) {
      qParam = `page=project_people_insights`;
      criteria = `project_number=${this.data.projectNumber}`;
    } else {
      qParam = `page=people_insights`;
      if (this.filterPayload) {
        criteria = this.filterPayload;
      }
    }

    if (criteria) {
      qParam += "&criteria=" + encodeURIComponent(criteria);
    }

    this.zohoService.getZohoReport(qParam).subscribe((res: any) => {
      if (res?.data?.length) {
        this.currentReportUrl = res.data[0].url;
      }
      this.dataLoaded = true;
      setTimeout(() => this.initDashboard(), 0);
    });
  }

  getDisplayLables() {
    this.displayLabels = this.commonService.getLabels();
  }

  /**Return list of filter based on the selectedTab */
  getFilterList() {
    let filterFields: string[] = [];

    switch (this.selectedTab.tab) {
      case 1:
        filterFields = [
          "portfolio",
          "subportfolio",
          "program",
          "project",
          "vendor",
          "month",
        ];
        break;
      case 2:
        filterFields = [
          "portfolio",
          "subportfolio",
          "program",
          "project",
          "vendor",
          "month",
        ];
        break;
      case 4:
        filterFields = [];
        break;
      case 3:
        filterFields = ["portfolio", "subportfolio", "program", "project"];
        break;
      case 5:
        filterFields = [
          "portfolio",
          "subportfolio",
          "program",
          "project",
          "vendor",
        ];
        break;
      default:
        filterFields = [
          "portfolio",
          "subportfolio",
          "program",
          "project",
          "vendor",
          "month",
          "jobCategory",
          "jobClassification",
          "country",
        ];
        break;
    }
    return filterFields;
  }

  checkPortfolioDisabled() {
    if (
      !this.userDetails.is_superuser &&
      (this.userDetails.owner_level === "sub_portfolio" ||
        this.userDetails.owner_level === "program")
    ) {
      return true;
    } else {
      return false;
    }
  }

  checkSubportfolioDisabled() {
    if (
      !this.userDetails.is_superuser &&
      this.userDetails.owner_level === "program"
    ) {
      return true;
    } else {
      return false;
    }
  }

  checkProgramDisabled() {
    if (
      !this.userDetails.is_superuser &&
      this.userDetails.owner_level === "project"
    ) {
      return true;
    } else {
      return false;
    }
  }

  getGMapRandomColor() {
    const colorNum = 360;
    const color = Math.floor(Math.random() * colorNum);
    return `hsla(${color}, 50%, 25%, 90%)`;
  }

  async getBrowseAIData() {
    this.spinner.show();
    this.workForceService
      .getBrowseAIData("IBM careers")
      .subscribe((res: any) => {
        this.spinner.hide();
        res.data.forEach((element: any) => {
          element.color = this.getGMapRandomColor();
          this.browseAIData.push(element);
        });
      });
  }

  openNewWindow(url: any) {
    window.open(url, "_blank", "width=600,height=400");
  }

  getList() {
    this.dataLoaded = false;
    this.resourcesSortOptions = JSON.parse(JSON.stringify(this.sortOpt));
    this.krrSortOptions = JSON.parse(JSON.stringify(this.sortOpt));
    this.attritionSortOptions = JSON.parse(JSON.stringify(this.sortOpt));
    if (this.resourcesSortOptions.indexOf(this.resourcesSortRecords) === -1) {
      this.resourcesSortRecords =
        this.resourcesEndValue - this.resourcesStartValue;
    }
    if (this.krrSortOptions.indexOf(this.krrSortRecords) === -1) {
      this.krrSortRecords = this.krrEndValue - this.krrStartValue;
    }
    if (this.attritionSortOptions.indexOf(this.attritionSortRecords) === -1) {
      this.attritionSortRecords =
        this.attritionEndValue - this.attritionStartValue;
    }
    forkJoin({
      resourceList: this.getAllResourceList(),
      attritionList: this.getAllAttritionList(),
      krrList: this.getKRRList(),
    }).subscribe({
      next: (results) => {
        this.allResourceList = results.resourceList;
        this.allAttritionList = results.attritionList;
        this.allKRRList = results.krrList;
        this.dataLoaded = true;
        if (this.resourcesSortRecords > this.allResourceList.count) {
          this.resourcesSortRecords = this.allResourceList.count;
          this.resourcesSortOptions.unshift(this.resourcesSortRecords);
        }
        if (this.attritionSortRecords > this.allAttritionList.count) {
          this.attritionSortRecords = this.allAttritionList.count;
          this.attritionSortOptions.unshift(this.attritionSortRecords);
        }
        if (this.krrSortRecords > this.allKRRList.count) {
          this.krrSortRecords = this.allKRRList.count;
          this.krrSortOptions.unshift(this.krrSortRecords);
        }
      },
      error: (err) => {
        this.spinner.hide();
        this.loggingService.error("Error occurred while fetching data:", err);
      },
    });
  }

  getAllResourceList() {
    this.spinner.show();
    if (this.resourcesCurrentPage > 0) {
      this.resourcesStartValue =
        (parseInt(this.resourcesCurrentPage, 10) - 1) *
        parseInt(this.resourcesSortRecords, 10);
    } else {
      this.resourcesStartValue = 0;
    }
    this.resourcesEndValue =
      parseInt(this.resourcesStartValue, 10) +
      parseInt(this.resourcesSortRecords, 10);
    const payload = this.getPayload();
    return this.workForceService
      .getResourceList(
        this.resourcesStartValue,
        this.resourcesEndValue,
        payload
      )
      .pipe(
        tap(() => this.spinner.hide()),
        catchError(() => {
          return of({ data: [], count: 0 }); // Handle error and return a fallback value
        })
      );
  }

  getAllAttritionList() {
    this.spinner.show();
    if (this.attritionCurrentPage > 0) {
      this.attritionStartValue =
        (parseInt(this.attritionCurrentPage, 10) - 1) *
        parseInt(this.attritionSortRecords, 10);
    } else {
      this.attritionStartValue = 0;
    }
    this.attritionEndValue =
      parseInt(this.attritionStartValue, 10) +
      parseInt(this.attritionSortRecords, 10);
    const payload = this.getPayload();
    return this.workForceService
      .getAttritionList(
        this.attritionStartValue,
        this.attritionEndValue,
        payload
      )
      .pipe(
        tap(() => this.spinner.hide()),
        catchError((err) => {
          this.loggingService.error("Error in getAllAttritionList:", err);
          return of({ data: [], count: 0 }); // Handle error and return a fallback value
        })
      );
  }

  getKRRList() {
    this.spinner.show();
    if (this.krrCurrentPage > 0) {
      this.krrStartValue =
        (parseInt(this.krrCurrentPage, 10) - 1) *
        parseInt(this.krrSortRecords, 10);
    } else {
      this.krrStartValue = 0;
    }
    this.krrEndValue =
      parseInt(this.krrStartValue, 10) + parseInt(this.krrSortRecords, 10);
    let payload = this.getPayload();
    return this.workForceService
      .getKKRList(this.krrStartValue, this.krrEndValue, payload)
      .pipe(
        tap(() => this.spinner.hide()),
        catchError((err) => {
          this.loggingService.error("Error in getKRRList:", err);
          return of({ data: [], count: 0 }); // Handle error and return a fallback value
        })
      );
  }

  getPayload() {
    let payload: any = {};
    let months: any = [];
    let jobCategory: any = [];
    let vendor: any = [];
    let classification: any = [];
    let country: any = [];
    let portfolio: any = [];
    let subportfolio: any = [];
    let program: any = [];
    let project: any = [];
    let selectedPortfolio = "";
    let selectedSubportfolio = "";
    let selectedProgram = "";
    let selectedProject = "";
    let selectedVendor = "";

    this.filterObj?.inputs?.forEach((element: any) => {
      if (this.isEmptyValue(element.value)) return;
      if (element.field === "month") {
        element.value.forEach((val: any) => {
          months.push(val.id);
        });
      }
      if (element.field === "jobCategory") {
        element.value.forEach((val: any) => {
          jobCategory.push(val.id);
        });
      }
      if (element.field === "vendor") {
        vendor = [element?.value?.id];
        selectedVendor = element?.value?.display_name;
      }
      if (element.field === "jobClassification") {
        element.value.forEach((val: any) => {
          classification.push(val.id);
        });
      }
      if (element.field === "country") {
        element.value.forEach((val: any) => {
          country.push(val.id);
        });
      }
      if (element.field === "portfolio") {
        portfolio = [element?.value?.id];
        selectedPortfolio = element?.value?.display_name;
      }
      if (element.field === "subportfolio") {
        subportfolio = [element?.value?.id];
        selectedSubportfolio = element?.value?.display_name;
      }
      if (element.field === "program") {
        program = [element?.value?.id];
        selectedProgram = element?.value?.display_name;
      }
      if (element.field === "project") {
        project = [element?.value?.id];
        selectedProject = element?.value?.display_name;
      }
    });
    if (months.length > 0) {
      payload = {
        month: months,
      };
    } else if (jobCategory.length > 0) {
      payload = {
        job_category: jobCategory,
      };
    } else if (classification.length > 0) {
      payload = {
        classification,
      };
    } else if (country.length > 0) {
      payload = {
        country,
      };
    } else if (vendor.length > 0) {
      payload = {
        vendor,
      };
    } else if (project.length > 0) {
      payload = {
        project,
      };
    } else if (program.length > 0) {
      payload = {
        program,
      };
    } else if (subportfolio.length > 0) {
      payload = {
        sub_portfolio: subportfolio,
      };
    } else if (portfolio.length > 0) {
      payload = {
        portfolio,
      };
    } else {
      this.loggingService.warn(this.warningText);
    }
    return payload;
  }

  handleTabUpdation() {
    switch (this.activeTab) {
      case 0:
        this.dataLoaded = false;
        this.getAllResourceList().subscribe({
          next: (res) => {
            this.allResourceList = res;
            if (this.resourcesSortRecords > this.allResourceList.count) {
              this.resourcesSortRecords = this.allResourceList.count;
              this.resourcesSortOptions.unshift(this.resourcesSortRecords);
            }
            this.dataLoaded = true;
          },
        });
        break;
      case 1:
        this.dataLoaded = false;
        this.getKRRList().subscribe({
          next: (res) => {
            this.allKRRList = res;
            if (this.krrSortRecords > this.allKRRList.count) {
              this.krrSortRecords = this.allKRRList.count;
              this.krrSortOptions.unshift(this.krrSortRecords);
            }
            this.dataLoaded = true;
          },
        });
        break;
      case 2:
        this.dataLoaded = false;
        this.getAllAttritionList().subscribe({
          next: (res) => {
            this.allAttritionList = res;
            if (this.attritionSortRecords > this.allAttritionList.count) {
              this.attritionSortRecords = this.allAttritionList.count;
              this.attritionSortOptions.unshift(this.attritionSortRecords);
            }
            this.dataLoaded = true;
          },
        });
        break;
      default:
        break;
    }
  }

  updateAiroInsight() {
    let pagename = "";
    let tab = this.selectedTab.tab;
    if (tab === 1) {
      pagename = "People Insights - Location Spead";
    } else if (tab === 2) {
      pagename = "People Insights - Personas/Profile Analysis";
    } else if (tab === 4) {
      pagename = "People Insights - Cost/Rate Analysis";
    } else if (tab === 3) {
      pagename = "People Insights - Data Access Analysis";
    } else if (tab === 5) {
      pagename = "People Insights - Attrition Analysis";
    } else {
      pagename = "People Insights - Workforce Catalog";
    }
    this.messageService.setGnews({ pagename: pagename });
  }

  changeTab(event: any) {
    this.activeTab = event.index;
    this.CurrentPage = 0;
    this.EndValue = 20;
    this.startValue = 0;
    this.handleTabUpdation();
  }

  getRecords() {
    if (this.CurrentPage > 0) {
      this.startValue =
        (parseInt(this.CurrentPage, 10) - 1) * parseInt(this.sortRecords, 10);
    } else {
      this.startValue = 0;
    }
    this.EndValue =
      parseInt(this.startValue, 10) + parseInt(this.sortRecords, 10);
    if (this.selectedTab?.tab === this.workforceCatalogTab) {
      if (!this.firstTimeLoad) {
        this.handleTabUpdation();
      }
      this.firstTimeLoad = false;
    }
  }

  editWorkForceById(id: number) {
    this.router.navigate([`workforce/edit/${btoa(id + "")}`]);
  }

  editWorkForceDetails(id: any, type: any, modal: any) {
    this.editingResourceId = id;
    this.spinner.show();
    if (type === "attrition") {
      this.workForceService
        .getWorkForceAttritionDataById(id)
        .subscribe((res: any) => {
          this.spinner.hide();
          this.patchWorkForceValues(res, modal);
        });
    } else if (type === "resource") {
      this.workForceService
        .getWorkForceResourceDataById(id)
        .subscribe((res: any) => {
          this.patchWorkForceValues(res, modal);
          this.spinner.hide();
        });
    } else if (type === "krr") {
      this.workForceService
        .getWorkForceKrrDataById(id)
        .subscribe((res: any) => {
          this.patchWorkForceValues(res, modal);
          this.spinner.hide();
        });
    } else {
      this.loggingService.warn(this.warningText);
    }
  }

  patchWorkForceValues(res: any, modal: any) {
    this.workForceResourceForm.patchValue(res);
    this.dialog.open(modal, {
      width: "80vw",
      maxHeight: "70vh",
      disableClose: true,
      autoFocus: false,
    });
  }

  closeModal(bool = false): void {
    this.dialogRef.close(bool);
  }

  cancel() {
    this.dialog.closeAll();
  }

  clickToDownload() {
    let url = "",
      name = "";
    if (this.activeTab === 0) {
      url = "workforce/resources/";
      name = "Resources";
    } else if (this.activeTab === 1) {
      url = "workforce/krrs/";
      name = "KRR/TT";
    } else if (this.activeTab === 2) {
      url = "workforce/attritions/";
      name = "Attrition";
    } else {
      this.loggingService.warn(this.warningText);
    }
    let payload: any = this.getPayload();
    payload.response_type = "csv";
    this.spinner.show();
    this.workForceService
      .downloadPeopleInsights(url, payload)
      .subscribe((res: any) => {
        const blobUrl = window.URL.createObjectURL(res);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = name + ".csv";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
        this.spinner.hide();
      });
  }

  loadResourceContentType(event: any, index: any, resource: any) {
    const payload = {
      contract_type: "T&M",
      contract_id: null,
      contract_name: null,
    };
    if (event === "T&M") {
      this.patchResourceContract(resource.id, payload);
    } else {
      this.getContractList(index, resource);
    }
  }

  loadResourceContract(event: any, index: any, resource: any) {
    const payload = {
      contract_type: "SOW",
      contract_id: event.contract_id,
      contract_name: event.contract_name,
    };
    this.allResourceList.data[index].contract_name = event.contract_name;
    this.patchResourceContract(resource.id, payload);
  }

  patchResourceContract(id: any, payload: any) {
    this.spinner.show();
    this.workForceService.updateResourceContract(id, payload).subscribe(() => {
      this.spinner.hide();
    });
  }

  getContractList(index: any, resource: any) {
    this.spinner.show();
    const params = {
      project_id: resource?.project,
      portfolio_name: resource?.portfolio_name,
      subportfolio_name: resource?.cost_center_name,
      program_name: resource?.resource_pool_name,
      vendor: resource?.company_name,
    };
    this.workForceService
      .getProjectVendorContractList(params)
      .subscribe((res: any) => {
        this.spinner.hide();
        this.allResourceList.data[index].contractList = res;
      });
  }
  /**
   * Checks if the country flag SVG exists for the given ISO 3166-1 alpha-3 code.
   * @param country The country alpha-3 code (e.g., 'IND', 'USA', 'GBR')
   * @returns true if the flag exists, false otherwise
   */
  countryFlagExists(country: string): boolean {
    if (!country) return false;
    // List of available country flag SVGs by ISO 3166-1 alpha-3 code
    const availableFlags = [
      "USA",
      "IND",
      "GBR",
      "CAN",
      "DEU",
      "AUS",
      "JPN",
      "BRA",
      "ESP",
      "PHL",
      "DNK",
      "RUS",
      "ISR",
      "IND",
      "MEX",
    ];
    return availableFlags.includes(country.toUpperCase());
  }

  switchTab(tabId: string) {
    this.activeTabName = tabId;
    setTimeout(() => window.dispatchEvent(new Event("resize")), 50);
  }

  switchTabByIndex(index: number) {
    this.activeTabIndex = index;
    setTimeout(() => window.dispatchEvent(new Event("resize")), 50);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
